/* eslint-disable @typescript-eslint/ban-ts-comment */
import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';
import { SwiperOptions } from 'swiper';

@Directive({
    selector: '[luiSwiper]',
    standalone: false
})
export class SwiperDirective implements AfterViewInit {
  private readonly swiperElement: HTMLElement;

  @Input() config?: SwiperOptions;

  constructor(private el: ElementRef<HTMLElement>) {
    this.swiperElement = el.nativeElement;
  }

  ngAfterViewInit() {
    Object.assign(this.swiperElement, this.config);

    // @ts-ignore
    this.swiperElement.initialize();
    // Promise.resolve().then(() => {

    //   console.log(this.swiperElement);
    // });

    // ngOnDestroy() {
    //   // this.swiperElement.destroy();
    // }
  }
}
